import * as React from 'react';
import './content.css';

export const contentHabitat: React.StatelessComponent<{}> = ({ children }) => {
  return <div className="content-habitat">{children}</div>;
};
